import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DrI18nService } from '../i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbsService } from '@app/core/services/breadcrumbs.service';
import { AuthenticationService } from '@app/core/authentication';
import { CurrencyService } from '@app/core/services/currency.service';
import { NotificationService } from '@app/core/services/notification.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Injectable({
  providedIn: 'root'
})
export class ComponentServiceBundle {

  constructor(public route: ActivatedRoute,
              public router: Router,
              public dialog: MatDialog,
              public drI18nService: DrI18nService,
              public translateService: TranslateService,
              public breadcrumbsService: BreadcrumbsService,
              public authenticationService: AuthenticationService,
              public currencyService: CurrencyService,
              public notificationService: NotificationService
  ) {

  }
}
